// check for existence of value (truthy tests evaluate to false for 0 values)
export const hasValue = (value) =>
    value || value === 0 || value === false

export const titleCase = (name) => 
    name ? name.replace(/\b\S/g, t => t.toUpperCase()) : ''

export const getBoolValueFromFormData = (formData, fieldId) =>
    formData && formData[fieldId] ? formData[fieldId].value === 'Y' : false

export const jumpToTop = () => {
    document.getElementById('overflow-container').scrollTo({ top: 0 });
}
export const scrollToTop = () => {
    document.getElementById('overflow-container').scrollTo({ top: 0, behavior: 'smooth' });
}